import { render, staticRenderFns } from "./CardRegisterForm.vue?vue&type=template&id=0b136f6a&scoped=true"
import script from "./CardRegisterForm.vue?vue&type=script&lang=js"
export * from "./CardRegisterForm.vue?vue&type=script&lang=js"
import style0 from "./CardRegisterForm.vue?vue&type=style&index=0&id=0b136f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b136f6a",
  null
  
)

export default component.exports